import React, { useState } from 'react';
import './css/masterDocSideBar.scss';

import Description from '../Description';
import useRedirect from '../customHooks/useRedirect';
import { DEMO_USER_PICTURE, placeDemoUserPicture } from '../../common/common';
import LazyImage from '../CustomLibraries/LazyImage';

const MasterDoctorSideBar = ({ data }) => {
  const [read, setRead] = useState(false);
  const { redirectTo } = useRedirect();
  const redirectToDoctorProfile = () => {
    if (data?.session_doctor_id) {
      redirectTo('SpeakerProfile', data?.session_doctor_id, data?.session_doctor_name);
    }
  };
  return (
    <div className="w-100 float-start d-flex justify-content-between masterDoctor pe-2 pb-3 mb-3 border-bottom border-light">
      <div
        className="rounded-circle masterDoctorPic cursorPointer overflow-hidden"
        onClick={redirectToDoctorProfile}
      >
        <LazyImage
          src={data?.session_doctor_image ?? DEMO_USER_PICTURE}
          fallback_image={DEMO_USER_PICTURE}
          className="object-fit-cover w-100 h-100 float-start"
          alt={data.session_doctor_name}
          logo
        />
      </div>
      <div className="masterDoctorRight flex-1 ps-3">
        <h4
          className="fs-4 text-black fw-medium mt-0 mb-1 cursorPointer"
          onClick={redirectToDoctorProfile}
        >
          {data.session_doctor_name}
          <span className="d-block fw-normal">{data.DepartmentName}</span>
        </h4>
        {data?.subtitle && (
          <Description
            click={redirectToDoctorProfile}
            data={data?.subtitle}
            onReadMoreClick={() => setRead(!read)}
          />
        )}
      </div>
    </div>
  );
};

export default MasterDoctorSideBar;
